import { FieldErrorMap } from "hooks/useFieldErrors";
import i18n from "locales/i18n";
import {
  checkRequired,
  validateElectricalLicenseNumber,
  validateExpiryDate,
} from "pages/formTools";

// Resolves the language per call, so messages follow the switcher.
const t = i18n.getFixedT(null, "profile");

export interface InstallationDraft {
  offeringEvInstallation: string;
  province: string;
  licenseFile: File | null;
  /** The licence already on file, so a vendor needn't upload it again. */
  licenseUrl: string | null;
  licenseNumber: string;
  licenseExpiryDate: string;
}

export const validateInstallation = (
  draft: InstallationDraft,
): FieldErrorMap => {
  const installs = draft.offeringEvInstallation === "Yes";

  return {
    offeringEvInstallation: checkRequired(
      t("installation.services"),
      draft.offeringEvInstallation,
    ),
    province: checkRequired(t("installation.province"), draft.province),
    licenseFile:
      installs && !draft.licenseFile && !draft.licenseUrl
        ? t("installation.upload_required")
        : null,
    licenseNumber: installs
      ? validateElectricalLicenseNumber({
          name: t("installation.license_name"),
          value: draft.licenseNumber,
          required: true,
          errorMessage: t("installation.license_digits"),
        })
      : null,
    licenseExpiryDate: installs
      ? validateExpiryDate({
          name: t("installation.license_expiry_label"),
          value: draft.licenseExpiryDate,
          required: true,
        })
      : null,
  };
};
